import { FC } from 'react';
import classNames from 'classnames';

interface Props {
  title: string;
  placeholder: string;
  showFavourites: boolean;
}

const Favourites: FC<Props> = ({
  title,
  placeholder,
  showFavourites = false,
  children,
}) => {
  const classes = classNames('favourites__inner', {
    'favourites__inner--empty': !showFavourites,
  });

  const renderPlaceholder = () => <p className="no-margin">{placeholder}</p>;

  return (
    <div className="favourites">
      <div className="favourites__title">
        <h3 className="favourites__title-text">{title}</h3>
      </div>

      <div className={classes}>
        {!showFavourites && renderPlaceholder()}
        {showFavourites && <ul className={classes}>{children}</ul>}
      </div>
    </div>
  );
};

export default Favourites;
